import * as api from "./api.js"
import * as types from "./types.js"


/*
 * POST (new person)
 * 
 */
const postRequest = () => ({
    type: types.POST_REQUEST
})
const postReceived = (payload) => ({
    type: types.POST_RECEIVED,
    payload
})
const postError = (e) => ({
    type: types.POST_ERROR,
    payload: e,
    error: true
})
export function post(person) {
    return dispatch => {
        dispatch(postRequest())
        return api.post(person)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postError(res.statusText))
            } else {
                return res.json()
                .then(id => dispatch(postReceived(id)))
            }
        })
    }
}

/*
 * LIST (all profiles)
 * 
 */
function listRequest() {
    return {
        type: types.LIST_REQUEST
    }
}

function listReceived(profiles) {
    return {
        type: types.LIST_RECEIVED,
        payload: profiles
    }
}

function listError(e) {
    return {
        type: types.LIST_ERROR,
        payload: e,
        error: true
    }
}

export function list(offset) {
    return dispatch => {
        dispatch(listRequest())
        return api.list(offset)
        .then(res => {
            if (res.status !== 200) {
                dispatch(listError(res.statusText))
            } else {
                return res.json()
                .then(profiles => dispatch(listReceived(profiles)))
            }
        })
    }
}

/*
 * DELETE (person)
 * 
 */
function deletePersonRequest() {
    return {
        type: types.DELETE_REQUEST
    }
}

function deletePersonReceived(id) {
    return {
        type: types.DELETE_RECEIVED,
        payload: { id }
    }
}

function deletePersonError(e) {
    return {
        type: types.DELETE_ERROR,
        payload: e,
        error: true
    }
}

export function deletePerson(id) {
    return dispatch => {
        dispatch(deletePersonRequest())
        return api.deletePerson(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(deletePersonError(res.statusText))
            } else {
                dispatch(deletePersonReceived(id))
            }
        })
    }
}

/*
 * CLEAR (all profiles)
 * 
 */
export function clearProfiles() {
    return dispatch => {
        dispatch({ type: types.CLEAR_PROFILES })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profiles/actions.js
 **/